<template>
  <el-card v-if="notices.length > 0" shadow="never" class="home-dashboard__card home-notices">
    <div slot="header">
      <span class="home-dashboard__card-title">{{ $t("avisos") }}</span>
    </div>
    <MessageRead ref="readMessage" />
    <div
      v-for="notice in notices"
      :key="notice.id"
      class="home-notices__row"
      :title="notice.subject"
      @click="openNotice(notice)"
    >
      <div class="home-notices__subject">{{ notice.subject }}</div>
      <div class="home-notices__date">{{ noticeDate(notice.createdAt) }}</div>
    </div>
  </el-card>
</template>

<script>
import moment from "moment";
// Avisos da plataforma: mensagens em destaque (highlight) da infra de
// notificações já existente. Comunicação administrada — não é dado pesado.
// O bloco se esconde quando não há avisos.
import { NotificationService } from "@/services/comum/notification.services";
import MessageRead from "@/xpost/views/comum/notification/message/MessageRead.vue";

export default {
  name: "HomeNotices",
  components: { MessageRead },
  data() {
    return {
      notices: [],
    };
  },
  methods: {
    // Backend manda "dd/MM/yyyy HH:mm" pronto; ISO também é aceito.
    noticeDate(raw) {
      if (!raw) {
        return "";
      }
      const parsed = moment(
        raw,
        ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY", moment.ISO_8601],
        true
      );
      return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "";
    },
    // Mesmo modal da tela de notificações; marca como lida ao abrir
    openNotice(notice) {
      if (!notice.read) {
        NotificationService.read([notice.id], true);
        notice.read = true;
        this.$bus.$emit("readMessage", "subtract", 1);
      }
      this.$refs.readMessage.open(notice);
    },
  },
  mounted() {
    const vm = this;
    NotificationService.list(3, 1, 0, 1)
      .then((response) => {
        vm.notices = Array.isArray(response) ? response.slice(0, 3) : [];
      })
      .catch(() => {
        vm.notices = []; // avisos são opcionais — não poluir a home com erro
      });
  },
};
</script>

<style>
.home-notices__row {
  padding: 8px 4px;
  border-bottom: 1px solid var(--me-border-lighter);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.home-notices__row:last-child {
  border-bottom: none;
}

.home-notices__row:hover {
  background-color: var(--me-fill);
}

.home-notices__subject {
  font-size: 13px;
  color: var(--me-text-regular);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-notices__date {
  font-size: 11px;
  color: var(--me-text-placeholder);
  margin-top: 2px;
}
</style>
